const Error404 = () => {
  return <p className="fs-1 fw-bold">404</p>;
};

export default Error404;
